import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import {
    SERVER_URI,
} from "../utility/config";


function DriverCreatedMessage(props) {
    window.setTimeout(function () {
        // Move to a new location 
        props.handleClose();
    }, 1700);
    return (
        <div >
            <h2 className="message_title">Uusi kuljettaja lisätty</h2>
        </div>
    );
}

function AddDriver(props) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({
        name: '',
        driverId: '',
    })
    const [doesExist, setDoesExist] = useState(false);
    let storage = window.localStorage;
    let userToken = storage.getItem("admin_token")

    //Look at this closer
    const doesIdExist = async (e) => {
        try {
            let ID = e.target.value
            let newID = ''
            newID = await axios.get(`${SERVER_URI}/does_driver_exist/${ID}`, { headers: { "Authorization": `Token ${userToken}` } })
            let exists = newID.data.driverExists
            if (exists === false) {
                setUserData({ ...userData, driverId: ID })
                setDoesExist(false)
            } else {
                alert("Kuljettaja Id on jo käytössä")
                setDoesExist(true)
            }
        } catch (e) {
            console.log("Error in ID", e)
        }

    }

    const onChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value })
    }

    // Submit
    const doSubmit = async (e) => {
        e.preventDefault()
        const dataToServer = {
            ...userData,
            driverId: Number(userData.driverId)
        }
        if (doesExist === false) {
            try {
                await axios.post(`${SERVER_URI}/add_driver/`, dataToServer, { headers: { "Authorization": `Token ${userToken}` } })
                props.dispatch({ type: "ADD_DRIVER", data: { newDriver: dataToServer } })
                setShow(!show);
            } catch (e) {
                console.log("Error in adding driver", e)
            }
        } else {
            alert("Id ei ole kelvollinen")
        }

    }
    return (
        <div className="popUp_card">
            <div className="popup-box">
                <div className="box">
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    {!show && (
                        <div>
                            <h2 className="popUp_title">Lisää kuljettaja</h2>
                            <form className="add_driver_form" onSubmit={e => doSubmit(e)}>
                                <label className="label_add" htmlFor="name">Nimi:</label>
                                <input type="text" id="name" name="name" onChange={onChange} placeholder="Nimi" required></input><span className="validity"></span> <br className="desktop-break" />
                                <label className="label_add" htmlFor="driverId">Kuljettajan ID:</label>
                                <input type="number" id="driverId" name="driverId" placeholder="ID" min="1" max="5000000000" onChange={doesIdExist} required></input><span className="validity"></span><br className="desktop-break" />
                                <input type="submit" id="gradient_Button" value="Lisää kuljettaja" />
                            </form></div>
                    )}
                    {show && <DriverCreatedMessage handleClose={props.handleClose} />}
                </div>
            </div>
        </div>

    );
}

export default AddDriver;